/* eslint react/no-multi-comp: 0, react/prop-types: 0 */
// eslint-disable-next-line
import React, { useState, useEffect, useRef } from 'react'; // eslint-disable-next-line
import { copiriAxiosPost, copiriPortalRequest } from '../../../api/api'; // eslint-disable-next-line
import config from '../../../config/config'; // eslint-disable-next-line
import { toast } from 'react-toastify';
// eslint-disable-next-line
import FormGroupInput from '../../../common/FormGroupInput';
// eslint-disable-next-line
import { Row, Col, Button } from 'react-bootstrap';
// eslint-disable-next-line
import CopiriLoader from '../../../common/CopiriLoader';
import image_loader from '../../../../assets/img/loader/small_loader.gif'; // eslint-disable-next-line
const PrintNameField = props => {
	// eslint-disable-next-line
	const { lodgeData, id, closeModal, updateLodgeModal, pageLanguageContent } = props; // eslint-disable-next-line
	const [checkDataChange, setCheckDataChange] = useState(false);
	const [showLoader, setShowLoader] = useState(false);
	const [inputField, setInputField] = useState({
		print_name: ''
	});

	const [validation, setValidation] = useState({
		error_print_name: ''
	});

	useEffect(() => {
		if (props.id) {
			const { print_name } = lodgeData;
			setInputField({ ...inputField, print_name });
		}
		// eslint-disable-next-line
	}, [props.id]);

	const inputsHandler = e => {
		setCheckDataChange(true);
		setInputField({ ...inputField, [e.target.name]: e.target.value });
	};

	function updateData() {
		let errors = { ...validation };
		var errorCount = 0;

		if (!inputField.print_name) {
			errors.error_print_name = pageLanguageContent['CLD071'];
			errorCount++;
		} else {
			errors.error_print_name = '';
		}
		var sendData = {};
		sendData['value'] = inputField['print_name'];
		sendData['type'] = 'print_name';

		setValidation(errors);
		if (errorCount <= 0) {
			setShowLoader(true);
			copiriPortalRequest('/organizations/' + id + '/additional-info', config.app_version, 'patch', sendData)
				.then(response => {
					setShowLoader(false);
					if (response.data.status && response.data.status === 'SUCCESS') {
						toast.success(pageLanguageContent['CLD119']);
						closeModal();
						updateLodgeModal('print_name', inputField['print_name']);
					}
				})
				.catch(error => {
					toast.error(error.response.data.result);
					setShowLoader(false);
				});
		}
	}

	return (
		<Row className='mt-2'>
			<Col lg={12}>
				<FormGroupInput
					id='print_name'
					label={pageLanguageContent['CLD158'] ? pageLanguageContent['CLD158'] : ''}
					placeholder={pageLanguageContent['CLD158'] ? pageLanguageContent['CLD158'] : ''}
					type='text'
					name='print_name'
					onChange={inputsHandler}
					value={inputField.print_name}
				/>
				{validation.error_print_name && <p className='formValidationError'>{validation.error_print_name}</p>}
			</Col>
			<Col lg={12}>
				<Button
					variant='primary'
					id={'confirmValidatebutton'}
					style={{ float: 'right', marginBottom: '15px' }}
					onClick={updateData}
				>
					{showLoader ? (
						<img src={image_loader} alt='loader' height='20' width='20' />
					) : pageLanguageContent['CLD124'] ? (
						pageLanguageContent['CLD124']
					) : (
						''
					)}
				</Button>
			</Col>
		</Row>
	);
};
export default PrintNameField;
